module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABJ0lEQVQ4T5XSv0vDQBTA8e+7WHXXDo66OrjYzroIDo4iuAlNCsU/wcFNxL/AuLu4iOgqGTpUk3ZREMGl0L1uom3uSUsLaUy03nTcuw/3fpwAlHx9FXgZ7LOWheXIk7VkTEYwEOVMDbuZUtkyQvnBlc44noQBQvRVoJ7GhR63wGxs2G9V5G0Qn4DWEESuBGlY8jUQ8BQurXLQrMrTVLDs65VCEWUBw1LoyuJUMJnB4PXQk40f0MR0rcPm8LKlr3DerEpvjPMhtLEMW68OcdjhjmOxf0JRZgQOk+lZw1FUkefx6DJTdT5o2XlW0p2d69Ou16T7W42fathLQxFuHl25n4BlXxsKDRWus+aY29V1X0+BHYTav+Cw6As9QdkG3vM+++h8NfSk+A3IYbYPfHu0oQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/file-number.png
// module id = wsKv
// module chunks = 1